<div [class]="containerClasses" *transloco="let t">
  <!-- Error message displayed above the input -->
  <div class="error-message">
    <span *ngIf="hasError && errorMessage">{{ t(errorMessage) }}</span>
  </div>

  <nz-input-group
    [ngClass]="{ 'error-input-group': hasError }"
    class="textarea-container input-round rounded-sm bg-green-50"
  >
    <textarea
      rows="4"
      nz-input
      (input)="onValueChange($any($event.target).value)"
      [value]="value"
      [placeholder]="placeholder"
      [disabled]="disabled"
      [ngClass]="{
        'error-input bg-orange-300': hasError,
        'bg-green-50': !hasError,
      }"
      class="custom-textarea"
    ></textarea>
  </nz-input-group>
</div>
